export default "__VITE_ASSET__CqCY$A5F__"